import {
    Col, Descriptions, Divider, Form, Input, Modal,
    Row, Space, Table, Tabs, Button,
    DatePicker,
    AutoComplete,
    InputNumber,
    TimePicker,
    Select,
    Typography,
    message
} from 'antd';
import moment from 'moment';
import numeral from 'numeral';
import { useEffect, useMemo, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { EditOutlined, DeleteOutlined, PlusCircleOutlined, SaveOutlined, ArrowLeftOutlined, FileTextOutlined, InboxOutlined } from '@ant-design/icons';
import { useSelector, useDispatch } from 'react-redux';
import { GetAPI, PostAPI } from '../../../../../redux';
import kdKemas from '../../../../../assets/kode_kemas.json';
import BillModal from './modal/BillModal';
import countries from '../../../../../assets/countries.json';

const { Option } = Select;
const { TabPane } = Tabs;

const defaultHeader = {
    "nomor_aju": "",
    "id_data": "",
    "npwp": "",
    "jns_manifest": "",
    "kd_jns_manifest": "",
    "kppbc": "",
    "no_bc_10": "",
    "tgl_bc_10": "",
    "no_bc_11": "",
    "tgl_bc_11": "",
    "nama_sarana_angkut": "",
    "kode_moda": "",
    "call_sign": "",
    "no_imo": "",
    "negara": "",
    "no_voyage_arrival": "",
    "departure_flight": "",
    "nahkoda": "",
    "handling_agent": "",
    "pelabuhan_asal": "",
    "pelabuhan_transit": "",
    "pelabuhan_bongkar": "",
    "pelabuhan_selanjutnya": "",
    "kade": "",
    "tgl_tiba": "",
    "tgl_kedatangan": "",
    "jam_kedatangan": "",
    "tgl_bongkar": "",
    "jam_bongkar": "",
    "tgl_muat": "",
    "jam_muat": "",
    "tgl_keberangkatan": "",
    "jam_keberangkatan": "",
    "total_pos": "",
    "total_kemasan": "",
    "total_kontainer": 0,
    "total_master_bl_awb": 0,
    "total_bruto": 0,
    "total_volume": 0,
    "flag_nihil": "",
    "status": "",
    "no_perbaikan": "N",
    "tgl_perbaikan": 0,
    "seri_perbaikan": "",
    "pemberitahu": "",
    "lengkap": "",
    "user": "",
    "id_asal_data": "",
    "id_modul": "",
    "waktu_rekam": "",
    "waktu_update": "",
    "versi_modul": ""
}

const defaultDetail = {
    "id_detil": "",
    "id_master": "",
    "nomor_aju": "",
    "kd_kelompok_pos": "",
    "no_pos": "",
    "no_sub_pos": "",
    "no_sub_sub_pos": "",
    "no_master_blawb": "",
    "tgl_master_blawb": "",
    "no_host_blawb": "",
    "tgl_host_blawb": "",
    "mother_vessel": "",
    "npwp_consignee": "",
    "nama_consignee": "",
    "almt_consignee": "",
    "neg_consignee": "",
    "npwp_shipper": "",
    "nama_shipper": "",
    "almt_shipper": "",
    "neg_shipper": "",
    "nama_notify": "",
    "almt_notify": "",
    "neg_notify": "",
    "pelabuhan_asal": "",
    "pelabuhan_transit": "",
    "pelabuhan_bongkar": "",
    "pelabuhan_akhir": "",
    "jumlah_kemasan": 0,
    "jenis_kemasan": "",
    "merk_kemasan": "",
    "jumlah_kontainer": "",
    "bruto": "",
    "volume": "",
    "fl_partial": "",
    "total_kemasan": 0,
    "total_kontainer": "",
    "status_detil": "",
    "fl_konsolidasi": "",
    "fl_pecah": "",
    "fl_perbaikan": "",
    "jenis_id_shipper": "",
    "jenis_id_consignee": ""
}

export default function MyFormPage() {
    const location = useLocation();
    const history = useHistory();
    const dispatch = useDispatch();
    const { configCache, airlineCache, airportCache, consigneeCache, hscodeCache } = useSelector(state => state.apps);
    const { userdata } = useSelector(state => state.auth);
    const [model, setModel] = useState({ header: [], detil: [], barang: [], dokumen: [], kontainer: [], master_entry: [], respon_header: [] });
    const [form] = Form.useForm();
    const [modalDetilForm] = Form.useForm();
    const [modalBarangForm] = Form.useForm();
    const [detilList, setDetilList] = useState([]);
    const [isDetilModalVisible, setIsDetilModalVisible] = useState(false);
    const [editingDetilIndex, setEditingDetilIndex] = useState(null);
    const [currentEditingDetil, setCurrentEditingDetil] = useState(null);
    const [editedAwbIds, setEditedAwbIds] = useState(() => new Set());
    const [billSearchKeyword, setBillSearchKeyword] = useState('');

    const getNumericOrderValue = (value) => {
        if (value === undefined || value === null) return 0;
        const numeric = parseInt(`${value}`.replace(/[^0-9]/g, ''), 10);
        return Number.isNaN(numeric) ? 0 : numeric;
    };

    const sortDetilRecords = (records = []) => {
        if (!Array.isArray(records)) return [];
        return [...records].sort((a = {}, b = {}) => {
            const kdDifference = getNumericOrderValue(a?.kd_kelompok_pos) - getNumericOrderValue(b?.kd_kelompok_pos);
            if (kdDifference !== 0) {
                return kdDifference;
            }
            return getNumericOrderValue(a?.no_pos) - getNumericOrderValue(b?.no_pos);
        });
    };

    const airportCountry = [
        ...new Map(
            airportCache.map(item => [item.country, {
                country: item.country,
                kota: item.kota
            }])
        ).values()
    ];

    let alns = airlineCache.map(item => ({
        ...item,
        value: `${item?.name?.toUpperCase()}`
    }))
    let alncds = airlineCache.map(item => ({
        ...item,
        value: `${item?.code}`
    }))
    const arps = useMemo(() => {
        if (!Array.isArray(airportCache)) return [];
        return airportCache.map(item => {
            const countryCode = `${item?.country || ''}`.toUpperCase();
            const countryName = item?.country_name || item?.country_desc || item?.kota || '';
            const airportCode = `${item?.code || ''}`.toUpperCase();
            const airportName = item?.name || '';
            const labelParts = [];
            if (countryCode) {
                labelParts.push(countryCode);
            }
            if (countryName) {
                labelParts.push(`(${countryName})`);
            }
            if (airportCode) {
                labelParts.push(airportCode);
            }
            if (airportName) {
                labelParts.push(`(${airportName})`);
            }
            const label = labelParts.join(' ').replace(/\s+/g, ' ').trim();
            return {
                ...item,
                value: item?.value || `${countryCode}${airportCode}`,
                label: label || item?.value,
            };
        });
    }, [airportCache]);
    const airportDetailMap = useMemo(() => {
        return arps.reduce((acc, option) => {
            if (option?.value) {
                acc[option.value] = option?.label || option?.value;
            }
            return acc;
        }, {});
    }, [arps]);
    const pelabuhanAsalValue = Form.useWatch('pelabuhan_asal', form);
    const pelabuhanTransitValue = Form.useWatch('pelabuhan_transit', form);
    const pelabuhanBongkarValue = Form.useWatch('pelabuhan_bongkar', form);
    const pelabuhanSelanjutnyaValue = Form.useWatch('pelabuhan_selanjutnya', form);
    const renderAirportDetail = (value) => {
        const detail = value ? airportDetailMap[value] : '';
        if (!detail) return null;
        return (
            <Typography.Text type="secondary" style={{ display: 'block', marginTop: 4 }}>
                {detail}
            </Typography.Text>
        );
    };
    const filterAirportOption = (inputValue = '', option = {}) => {
        const regex = new RegExp(inputValue, 'i');
        return regex.test(option?.value || '') || regex.test(option?.label || '');
    };
    let arpcs = airportCountry.map(item => ({
        ...item,
        value: `${item?.country} - ${item?.kota}`
    }))

    let cns = consigneeCache.map(item => ({
        ...item,
        value: `${item?.name}`,
        label: `${item?.name}`,
    }))

    useEffect(() => {
        if (location.state) {
            const locState = location.state;
            const transformedDetil = locState?.detil?.map(det => {
                const barangForDetil = locState?.barang.filter(b => b?.id_detil === det?.id_detil);
                return { ...det, barang: barangForDetil || [] };
            });
            setModel(prev => {
                const nextHeader = Array.isArray(locState?.header) ? locState.header : prev.header;
                const nextDetil = Array.isArray(transformedDetil)
                    ? transformedDetil
                    : Array.isArray(locState?.detil)
                        ? locState.detil
                        : prev.detil;
                const normalizedDetil = sortDetilRecords(nextDetil || []);

                return {
                    ...prev,
                    ...locState,
                    header: nextHeader,
                    detil: normalizedDetil,
                    barang: Array.isArray(locState?.barang) ? locState.barang : prev.barang,
                    dokumen: Array.isArray(locState?.dokumen) ? locState.dokumen : prev.dokumen,
                    kontainer: Array.isArray(locState?.kontainer) ? locState.kontainer : prev.kontainer,
                    master_entry: Array.isArray(locState?.master_entry) ? locState.master_entry : prev.master_entry,
                    respon_header: Array.isArray(locState?.respon_header) ? locState.respon_header : prev.respon_header,
                };
            });
            form.setFieldsValue(locState.header?.[0] || {});
        }
    }, [location.state, form]);

    useEffect(() => {
        if (!location.state?.isCreate || (model?.header?.length ?? 0) > 0) return;

        const headerDefaults = {
            jns_manifest: 'IA',
            kd_jns_manifest: 'RK',
            kode_moda: '4',
            flag_nihil: 'N',
            status: 1,
            lengkap: 'Y',
            npwp: configCache?.npwp || '',
            kppbc: configCache?.kode_kantor || '',
            handling_agent: configCache?.name?.toUpperCase() || '',
            pemberitahu: configCache?.name?.toUpperCase() || '',
            user: userdata?.username || '',
        };

        setModel(prev => ({
            ...prev,
            ...location.state,
            isCreate: true,
            header: Array.isArray(prev?.header) && prev.header.length ? prev.header : [headerDefaults],
            detil: Array.isArray(prev?.detil) ? prev.detil : [],
            barang: Array.isArray(prev?.barang) ? prev.barang : [],
            dokumen: Array.isArray(prev?.dokumen) ? prev.dokumen : [],
            kontainer: Array.isArray(prev?.kontainer) ? prev.kontainer : [],
            master_entry: Array.isArray(prev?.master_entry) ? prev.master_entry : [],
            respon_header: Array.isArray(prev?.respon_header) ? prev.respon_header : [],
        }));

        form.setFieldsValue(headerDefaults);
    }, [location.state?.isCreate, model?.header?.length, configCache, userdata?.username, form]);

    const showDetilModal = () => {
        modalDetilForm.resetFields();
        const nextNoPos = ((model?.detil?.length || 0) + 1).toString().padStart(3, '0');
        modalDetilForm.setFieldsValue({ no_pos: nextNoPos });
        setEditingDetilIndex(null);
        setCurrentEditingDetil(null);
        setIsDetilModalVisible(true);
    };

    const handleEditDetil = (record) => {
        const barang = model.barang.find(item => item?.id_detil === record?.id_detil);
        const indexInDetil = (model?.detil || []).findIndex(item => item?.id_detil === record?.id_detil);
        modalDetilForm.setFieldsValue({ ...record, ...barang });
        setEditingDetilIndex(indexInDetil >= 0 ? indexInDetil : null);
        setCurrentEditingDetil({ ...record, ...barang });
        setIsDetilModalVisible(true);
    };

    const handleDetilModalOk = (values) => {
        const { dokumen = [], kontainer = [], ...details } = values;
        const baseDetilList = [...(model?.detil || [])];
        let newBarang = [...(model?.barang || [])];
        const idDetil = moment().unix();
        const detailId = currentEditingDetil?.id_detil || `${idDetil}`;
        const updatedDetilRecord = { ...currentEditingDetil, ...values, dokumen, kontainer, id_detil: detailId };

        const hsCodes = values?.hs_codes || [];

        const isEditingExisting = editingDetilIndex !== null && editingDetilIndex >= 0;
        let savedDetailRecord = updatedDetilRecord;
        let updatedDetilList = baseDetilList;

        if (isEditingExisting) {
            updatedDetilList = baseDetilList.map(item =>
                item?.id_detil === detailId ? updatedDetilRecord : item
            );
        } else {
            savedDetailRecord = {
                ...defaultDetail,
                ...details,
                dokumen,
                kontainer,
                hs_codes: hsCodes,
                "id_detil": detailId,
                "id_master": "null",
                "nomor_aju": model?.header[0]?.nomor_aju || "",
                "no_sub_pos": "0000",
                "no_sub_sub_pos": "0000",
                "mother_vessel": "-",
                "neg_consignee": "",
                "neg_shipper": "",
                "neg_notify": "",
                "pelabuhan_transit": values?.pelabuhan_akhir,
                "pelabuhan_bongkar": values?.pelabuhan_akhir,
                "merk_kemasan": "-",
                "jumlah_kontainer": "",
                "fl_partial": "",
                "total_kontainer": "0",
                "status_detil": "03",
                "fl_konsolidasi": "",
                "fl_pecah": "",
                "fl_perbaikan": "",
                "jenis_id_shipper": "",
                "jenis_id_consignee": "NPWP",
                "jumlah_kemasan": values?.total_kemasan
            };
            updatedDetilList = [...baseDetilList, savedDetailRecord];
        }

        const sortedDetil = sortDetilRecords(updatedDetilList);

        const idBarang = moment().unix();
        const primaryHs = hsCodes?.[0] || {};
        const barangBaru = {
            id_barang: currentEditingDetil?.id_barang || primaryHs?.id_barang || idBarang,
            id_detil: detailId,
            seri_barang: currentEditingDetil?.seri_barang || 1,
            hs_code: primaryHs?.hs_code || "",
            uraian_barang: primaryHs?.uraian_barang || "",
        };

        savedDetailRecord = { ...savedDetailRecord, ...barangBaru };

        if (isEditingExisting) {
            const editDataById = (data, id_detil, update) =>
                data.map(item => (item.id_detil === id_detil ? { ...update } : item));
            newBarang = editDataById(newBarang, detailId, barangBaru);
        } else {
            newBarang.push(barangBaru);
        }

        const totalKemasan = sortedDetil?.reduce((acc, cur) => acc + parseInt(cur?.jumlah_kemasan || 0), 0);
        const totalBruto = sortedDetil?.reduce((acc, cur) => acc + parseInt(cur?.bruto || 0), 0);
        const totalVolume = sortedDetil?.reduce((acc, cur) => acc + parseFloat(cur?.volume || 0), 0);

        let newHeader = model?.header.map((item, index) =>
            index === 0 ? {
                ...item, total_kemasan: totalKemasan, total_bruto: totalBruto, total_volume: totalVolume
            } : item
        );

        const timestamp = moment().valueOf();
        const dokumenDenganMeta = dokumen.map((doc, index) => ({
            ...doc,
            id_dokumen: doc?.id_dokumen || `${timestamp + index}`,
            id_detil: detailId,
        }));
        const dokumenLain = Array.isArray(model?.dokumen) ? model.dokumen.filter(item => item.id_detil !== detailId) : [];

        const kontainerDenganMeta = kontainer.map((item, index) => {
            const getVal = (key) => item[key] ?? item[key.replace(/_/g, ' ')];
            const idKontainer = getVal('id_kontainer') || `KON-${timestamp + index}`;
            return {
                id_kontainer: idKontainer,
                id_detil: detailId,
                seri_kontainer: getVal('seri_kontainer') || '',
                nomor_kontainer: getVal('nomor_kontainer') || '',
                ukuran_kontainer: getVal('ukuran_kontainer') || '',
                tipe_kontainer: getVal('tipe_kontainer') || '',
                jenis_kontainer: getVal('jenis_kontainer') || '',
                nomor_segel: getVal('nomor_segel') || '',
                status_kontainer: getVal('status_kontainer') || '',
            };
        });
        const kontainerLain = Array.isArray(model?.kontainer)
            ? model.kontainer.filter(item => (item.id_detil || item['id detil']) !== detailId)
            : [];
        setModel(prev => ({
            ...prev,
            header: newHeader,
            detil: sortedDetil,
            barang: newBarang,
            dokumen: [...dokumenLain, ...dokumenDenganMeta],
            kontainer: [...kontainerLain, ...kontainerDenganMeta],
        }));
        setDetilList(sortedDetil);
        const nextEditingIndex = sortedDetil.findIndex(item => item?.id_detil === detailId);
        setEditingDetilIndex(nextEditingIndex >= 0 ? nextEditingIndex : null);
        setCurrentEditingDetil(savedDetailRecord);
        modalDetilForm.setFieldsValue(savedDetailRecord);
        message.success('Detail Bill of Lading berhasil disimpan');
        form.setFieldsValue(newHeader[0] || {});
        setEditedAwbIds(prev => {
            const next = new Set(prev);
            next.add(detailId);
            return next;
        });
    };

    const handleDetilModalCancel = () => {
        setIsDetilModalVisible(false);
    };

    const handleDeleteDetil = (record) => {
        Modal.confirm({
            title: 'Konfirmasi',
            content: 'Apakah Anda yakin ingin menghapus data ini?',
            okText: 'Ya',
            cancelText: 'Batal',
            onOk() {
                const targetId = record?.id_detil;
                const newDetil = (model.detil || []).filter(item => item?.id_detil !== targetId);
                const sortedDetil = sortDetilRecords(newDetil);
                setModel(prev => ({ ...prev, detil: sortedDetil }));
            },
        });
    };

    const handleNext = () => {
        const nextIndex = editingDetilIndex + 1;
        if (nextIndex < detilList.length) {
            const nextRecord = detilList[nextIndex];
            modalDetilForm.setFieldsValue(nextRecord);
            setEditingDetilIndex(nextIndex);
            setCurrentEditingDetil(nextRecord);
        }
    };

    const handleBack = () => {
        const prevIndex = editingDetilIndex - 1;
        if (prevIndex >= 0) {
            const prevRecord = detilList[prevIndex];
            modalDetilForm.setFieldsValue(prevRecord);
            setEditingDetilIndex(prevIndex);
            setCurrentEditingDetil(prevRecord);
        }
    };

    const handleSelectDetil = (idDetil) => {
        if (!idDetil) return;
        const targetIndex = detilList.findIndex(item => item?.id_detil === idDetil);
        if (targetIndex >= 0) {
            const targetRecord = detilList[targetIndex];
            modalDetilForm.setFieldsValue(targetRecord);
            setEditingDetilIndex(targetIndex);
            setCurrentEditingDetil(targetRecord);
        }
    };

    const formatTwoDecimalDisplay = (value) => {
        if (value === undefined || value === null || value === '') return '';
        const numericValue = typeof value === 'number' ? value : numeral(value).value();
        if (numericValue === null || Number.isNaN(numericValue)) return '';
        return numeral(numericValue).format('0,0.[00]');
    };

    const parseTwoDecimalValue = (value) => {
        if (value === undefined || value === null || value === '') return null;
        const numericValue = numeral(value).value();
        if (numericValue === null || Number.isNaN(numericValue)) return null;
        return Math.round(numericValue * 100) / 100;
    };

    const detilColumns = [
        {
            title: 'No',
            key: 'no',
            render: (_, __, index) => index + 1
        },
        { title: 'Kd No pos', dataIndex: 'kd_kelompok_pos', key: 'kd_kelompok_pos' },
        {
            title: 'Master Awb', dataIndex: 'no_master_blawb', key: 'no_master_blawb',
            render: (text, record) => (
                <span style={editedAwbIds.has(record?.id_detil) ? { fontWeight: 600, color: '#389e0d' } : undefined}>
                    {text}
                </span>
            )
        },
        {
            title: 'Host Awb', dataIndex: 'no_host_blawb', key: 'no_host_blawb',
            render: (text, record) => (
                <span style={editedAwbIds.has(record?.id_detil) ? { fontWeight: 600, color: '#389e0d' } : undefined}>
                    {text}
                </span>
            )
        },
        { title: 'Jenis Kemasan', dataIndex: 'jenis_kemasan', key: 'jenis_kemasan' },
        { title: 'Jumlah Kemasan', dataIndex: 'jumlah_kemasan', key: 'jumlah_kemasan' },
        { title: 'Total Kemasan', dataIndex: 'total_kemasan', key: 'total_kemasan' },
        { title: 'Bruto', dataIndex: 'bruto', key: 'bruto' },
        {
            title: 'Aksi',
            key: 'action',
            render: (_, record) => (
                <Space>
                    <Button type="link" onClick={() => {
                        handleEditDetil(record)
                    }} icon={<EditOutlined />}>
                        Edit
                    </Button> |
                    <Button type="link" danger onClick={() => handleDeleteDetil(record)} icon={<DeleteOutlined />}>
                        Hapus
                    </Button>
                </Space>
            ),
        },
    ];

    const filteredDetilData = useMemo(() => {
        const source = sortDetilRecords(Array.isArray(model?.detil) ? model.detil : []);
        const keyword = billSearchKeyword.trim().toLowerCase();

        if (!keyword) {
            return source;
        }

        return source.filter(item => {
            const masterAwb = `${item?.no_master_blawb || ''}`.toLowerCase();
            const hostAwb = `${item?.no_host_blawb || ''}`.toLowerCase();
            return masterAwb.includes(keyword) || hostAwb.includes(keyword);
        });
    }, [model?.detil, billSearchKeyword]);

    const jumlahKemasan = filteredDetilData.reduce((acc, cur) => acc + parseFloat(cur?.jumlah_kemasan || 0), 0);
    const totalKemasan = filteredDetilData.reduce((acc, cur) => acc + parseFloat(cur?.total_kemasan || 0), 0);
    const totalBruto = filteredDetilData.reduce((acc, cur) => acc + parseFloat(cur?.bruto || 0), 0);

    const handleSave = (headerValues) => {
        const total_master_bl_awb = new Set(model?.detil?.map(item => item.no_master_blawb)).size;
        const total_bruto = model?.detil?.reduce((acc, cur) => acc + parseFloat(cur?.bruto || 0), 0).toFixed(4);
        const total_volume = model?.detil?.reduce((acc, cur) => acc + parseFloat(cur?.volume || 0), 0);
        const jumlah_kemasan = model?.detil?.reduce((acc, cur) => acc + parseFloat(cur?.jumlah_kemasan || 0), 0);

        let obj = [];

        const resultBarang = [];
        const resultKontainer = [];
        const idBarang = moment().unix() * 100;
        model?.detil?.forEach(item => {
            (item.hs_codes || []).forEach(hs => {
                resultBarang.push({
                    id_barang: hs?.id_barang || `${idBarang}`,
                    id_detil: hs?.id_detil || item?.id_detil,
                    seri_barang: 1,
                    hs_code: hs.hs_code,
                    uraian_barang: hs.uraian_barang
                });
            });

            (item.kontainer || []).forEach((kon, idx) => {
                const getVal = (key) => kon[key] ?? kon[key.replace(/_/g, ' ')];
                resultKontainer.push({
                    id_kontainer: getVal('id_kontainer') || `KON-${moment().valueOf()}${idx}`,
                    id_detil: getVal('id_detil') || item?.id_detil,
                    seri_kontainer: getVal('seri_kontainer') || idx + 1,
                    nomor_kontainer: getVal('nomor_kontainer') || '',
                    ukuran_kontainer: getVal('ukuran_kontainer') || '',
                    tipe_kontainer: getVal('tipe_kontainer') || '',
                    jenis_kontainer: getVal('jenis_kontainer') || '',
                    nomor_segel: getVal('nomor_segel') || '',
                    status_kontainer: getVal('status_kontainer') || '',
                });
            });
        });

        if (model?.isCreate) {
            obj = {
                ...model,
                header: [{
                    ...defaultHeader,
                    ...headerValues,
                    "nomor_aju": "",
                    "id_data": "1",
                    "npwp": configCache?.npwp || "",
                    "jns_manifest": "IA",
                    "kd_jns_manifest": "RK",
                    "kppbc": configCache?.kode_kantor || "",
                    "kode_moda": "4",
                    "no_voyage_arrival": headerValues?.header?.[0]?.no_imo || "",
                    "handling_agent": configCache?.name || "",
                    "flag_nihil": "N",
                    "status": 1,
                    "pemberitahu": configCache?.name || "",
                    "lengkap": "Y",
                    "user": userdata?.username || "",
                    "id_modul": "V050100042664",
                    "waktu_rekam": moment().format('DD-MM-YYYY'),
                    "waktu_update": moment().format('DD-MM-YYYY'),
                    "versi_modul": "2002",
                    "total_pos": model?.detil?.length,
                    "total_kemasan": jumlah_kemasan,
                    "total_kontainer": 0,
                    "total_master_bl_awb": total_master_bl_awb,
                    "total_bruto": total_bruto,
                    "total_volume": `${total_volume}`,
                }],
                detil: model?.detil?.map(({ barang, ...rest }) => rest),
                barang: resultBarang,
                kontainer: resultKontainer
            };
        } else {
            obj = {
                ...model,
                header: [{
                    ...model?.header?.[0],
                    ...headerValues
                }],
                detil: model?.detil?.map(({ barang, ...rest }) => rest),
                barang: resultBarang,
                kontainer: resultKontainer
            };
        }

        const url = `api/v1/rskp/process`
        dispatch(PostAPI({ url, data: obj })).then(resp => {
            if (resp?.payload) {
                history.goBack()
            }
        })
    };

    const formatAwbNumber = (value) => {
        let str = value;

        if (/^\d/.test(str)) {
            if (str.length > 3 && str.substring(3, 4) !== '-') {
                str = str.substring(0, 3) + '-' + str.substring(3);
            }
        }
        return str;
    }

    useEffect(() => {
        setDetilList(sortDetilRecords(model.detil || []));
    }, [model.detil]);

    const count = (model?.detil ?? []).reduce(
        (acc, item) => {
            if (item.isconsole === true) acc.true += 1;
            else if (item.isconsole === false) acc.false += 1;
            return acc;
        },
        { true: 0, false: 0 }
    );

    const fectAutogateData = () => {
        if (!location.state?.isCreate || (model?.header?.length ?? 0) > 0) return;
        dispatch(GetAPI({ url: 'api/v1/config/no_aju/123' }))
            .then(resp => {
                form.setFieldsValue({ nomor_aju: resp?.payload?.data });
            })
    }

    useEffect(() => {
        fectAutogateData()
    }, [])
    return (
        <Form layout="vertical" form={form} onFinish={handleSave}>
            <Tabs defaultActiveKey="1">
                <TabPane
                    key="1"
                    tab={
                        <>
                            <FileTextOutlined style={{ marginRight: 4 }} />
                            Data Header
                        </>
                    }
                >
                    <Descriptions bordered column={2}>
                        <Descriptions.Item label="Nama Perusahaan">
                            {configCache?.name?.toUpperCase()}
                        </Descriptions.Item>
                        <Descriptions.Item label="NPWP Perusahaan">
                            {configCache?.npwp}
                        </Descriptions.Item>
                        <Descriptions.Item label="Alamat Perusahaan">
                            {configCache?.address?.toUpperCase()}
                        </Descriptions.Item>
                        <Descriptions.Item label="Kantor Pelayanan">
                            {configCache?.kode_kantor}
                        </Descriptions.Item>
                    </Descriptions>
                    <Row gutter={16}>
                        <Col span={10}>
                            <Divider orientation="left">BC</Divider>
                            <Form.Item label="Nomor Aju" name="nomor_aju">
                                <Input disabled autoComplete="off" style={{ width: "100%" }} />
                            </Form.Item>
                            <Form.Item label="Jenis Kemasan" name="jns_manifest" style={{ marginTop: -15 }}>
                                <Input autoComplete="off" style={{ width: "100%" }} disabled />
                            </Form.Item>
                            <Form.Item label="Kode Jenis Kemasan" name="kd_jns_manifest" style={{ marginTop: -15 }}>
                                <Select allowClear>
                                    <Option value="RK">RK - RKSP (INITIAL MANIFEST)</Option>
                                    <Option value="EM">EM - ENTRY MANIFEST</Option>
                                    <Option value="IM">IM - INWARD MANIFEST</Option>
                                    <Option value="OM">OM - OUTWARD MANIFEST</Option>
                                </Select>
                            </Form.Item>
                            <Form.Item label="No Document PEB/PIB" name="no_dokument" style={{ marginTop: -15 }}>
                                <Input autoComplete="off" style={{ width: "100%" }} />
                            </Form.Item>
                            <Row gutter={16}>
                                <Col span={12}>
                                    <Form.Item label="No BC 10" name="no_bc_10" style={{ marginTop: -15 }}>
                                        <Input autoComplete="off" style={{ width: "100%" }} />
                                    </Form.Item>
                                    <Form.Item label="No Bc 11" name="no_bc_11" style={{ marginTop: -15 }}>
                                        <Input autoComplete="off" style={{ width: "100%" }} />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item
                                        label="Tgl Bc 10"
                                        name="tgl_bc_10"
                                        getValueProps={(value) => ({
                                            value: value ? moment(value, 'DD-MM-YYYY') : null,
                                        })}
                                        getValueFromEvent={(_, dateString) => dateString}
                                        style={{ marginTop: -15 }}
                                    >
                                        <DatePicker
                                            format="DD-MM-YYYY"
                                            style={{ width: '100%' }}
                                            placeholder=''
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label="No Bc 11"
                                        name="tgl_bc_11"
                                        getValueProps={(value) => ({
                                            value: value ? moment(value, 'DD-MM-YYYY') : null,
                                        })}
                                        getValueFromEvent={(_, dateString) => dateString}
                                        style={{ marginTop: -15 }}
                                    >
                                        <DatePicker
                                            format="DD-MM-YYYY"
                                            style={{ width: '100%' }}
                                            placeholder=''
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Col>
                        <Col span={14}>
                            <Divider orientation="left">Sarana Pengangkut</Divider>
                            <Row gutter={16}>
                                <Col span={12}>
                                    <Form.Item label="Nama Pesawat" name="nama_sarana_angkut"
                                        rules={[{ required: true, message: 'Nama pengangkut wajib di isi' }]}
                                    >
                                        <AutoComplete
                                            options={alns}
                                            filterOption={(inputValue, option) => {
                                                const regex = new RegExp(inputValue, 'i');
                                                return regex.test(option.value);
                                            }}
                                            onInput={e => e.target.value = e.target.value.toUpperCase()}
                                        />
                                    </Form.Item>
                                    <Form.Item label="No. Register" name="no_imo"
                                        rules={[{ required: true, message: 'Callsign/Register wajib di isi' }]}
                                        style={{ marginTop: -15 }}
                                    >
                                        <AutoComplete
                                            maxLength={2}
                                            options={alncds}
                                            onInput={e => e.target.value = e.target.value.toUpperCase()}
                                            filterOption={(inputValue, option) => {
                                                const regex = new RegExp(inputValue, 'i');
                                                return regex.test(option.value);
                                            }}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label="Call Sign"
                                        name="call_sign"
                                        rules={[{ required: true, message: 'Flight Number wajib di isi' }]}
                                        style={{ marginTop: -15 }}
                                    >
                                        <Input
                                            autoComplete="off"
                                            onInput={e => e.target.value = e.target.value.toUpperCase()}
                                        />
                                    </Form.Item>

                                    <Form.Item
                                        label="No. Arrival Flight"
                                        name="no_voyage_arrival"
                                        rules={[{ required: true, message: 'No. Arrival Flight wajib di isi' }]}
                                        style={{ marginTop: -15 }}
                                    >
                                        <Input
                                            autoComplete="off"
                                            onInput={e => e.target.value = e.target.value.toUpperCase()}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label="No. Departure Flight"
                                        name="departure_flight"
                                        rules={[{ required: true, message: 'No. Departure Flight wajib di isi' }]}
                                        style={{ marginTop: -15 }}
                                    >
                                        <Input
                                            autoComplete="off"
                                            onInput={e => e.target.value = e.target.value.toUpperCase()}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label="Handling Agent"
                                        name="handling_agent"
                                        rules={[{ required: true, message: 'Handling Agent wajib di isi' }]}
                                        style={{ marginTop: -15 }}
                                    >
                                        <Input
                                            autoComplete="off"
                                            onInput={e => e.target.value = e.target.value.toUpperCase()}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={12} style={{ marginTop: 15 }}>
                                    <Form.Item label="Kode Negara" name="negara"
                                        rules={[{ required: true, message: 'Kode Negara wajib di isi' }]}
                                        style={{ marginTop: -15 }}
                                    >
                                        <AutoComplete
                                            options={countries.map(item => ({
                                                value: item.code,
                                                label: `${item.code} - ${item.name}`
                                            }))}
                                            onInput={e => e.target.value = e.target.value.toUpperCase()}
                                            filterOption={(inputValue, option) =>
                                                option?.label?.toUpperCase().includes(inputValue.toUpperCase())
                                            }
                                        />
                                    </Form.Item>

                                    <Row gutter={16}>
                                        <Col span={12}>
                                            <Form.Item
                                                label="Tanggal Tiba"
                                                name="tgl_tiba"
                                                rules={[{ required: true, message: 'Tanggal Tiba wajib di isi' }]}
                                                getValueProps={(value) => ({
                                                    value: value ? moment(value, 'DD-MM-YYYY') : null,
                                                })}
                                                getValueFromEvent={(_, dateString) => dateString}
                                                style={{ marginTop: -15 }}
                                            >
                                                <DatePicker
                                                    format="DD-MM-YYYY"
                                                    style={{ width: '100%' }}
                                                    placeholder=''
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col span={12}>
                                            <Form.Item
                                                label="Jam Tiba"
                                                name="jam_tiba"
                                                rules={[{ required: true, message: 'Jam Tiba wajib di isi' }]}
                                                getValueProps={(value) => ({
                                                    value: value ? moment(value, 'HH:mm:ss') : null,
                                                })}
                                                getValueFromEvent={(_, timeString) => timeString}
                                                style={{ marginTop: -15 }}
                                            >
                                                <TimePicker
                                                    format="HH:mm:ss"
                                                    style={{ width: '100%' }}
                                                    placeholder=""
                                                />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                        <Col span={10}>
                            <Divider orientation="left">Bandara</Divider>
                            <Form.Item label="Bandara Asal" name="pelabuhan_asal"
                                rules={[{ required: true, message: 'Bandara Asal wajib di isi' }]}
                                extra={renderAirportDetail(pelabuhanAsalValue)}
                            >
                                <AutoComplete
                                    maxLength={5}
                                    options={arps}
                                    onInput={e => e.target.value = e.target.value.toUpperCase()}
                                    filterOption={filterAirportOption}
                                />
                            </Form.Item>
                            <Form.Item label="Bandara Transit" name="pelabuhan_transit"
                                style={{ marginTop: -15 }}
                                rules={[{ required: true, message: 'Bandara Transit wajib di isi' }]}
                                extra={renderAirportDetail(pelabuhanTransitValue)}
                            >
                                <AutoComplete
                                    maxLength={5}
                                    options={arps}
                                    onInput={e => e.target.value = e.target.value.toUpperCase()}
                                    filterOption={filterAirportOption}
                                />
                            </Form.Item>
                            <Form.Item label="Bandara Bongkar" name="pelabuhan_bongkar"
                                rules={[{ required: true, message: 'Bandara Bongkar wajib di isi' }]}
                                style={{ marginTop: -15 }}
                                extra={renderAirportDetail(pelabuhanBongkarValue)}
                            >
                                <AutoComplete
                                    maxLength={5}
                                    options={arps}
                                    onInput={e => e.target.value = e.target.value.toUpperCase()}
                                    filterOption={filterAirportOption}
                                />
                            </Form.Item>
                            <Form.Item label="Bandara Selanjutnya" name="pelabuhan_selanjutnya"
                                rules={[{ required: true, message: 'Bandara Transit wajib di isi' }]}
                                style={{ marginTop: -15 }}
                                extra={renderAirportDetail(pelabuhanSelanjutnyaValue)}
                            >
                                <AutoComplete
                                    maxLength={5}
                                    options={arps}
                                    onInput={e => e.target.value = e.target.value.toUpperCase()}
                                    filterOption={filterAirportOption}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={14}>
                            <Divider orientation="left">Total Manifest</Divider>
                            <Row gutter={16}>
                                <Col span={12}>
                                    <Form.Item label="Total Console">
                                        <Input disabled value={count.true} autoComplete="off" style={{ width: "100%" }} />
                                    </Form.Item>
                                    <Form.Item label="Total POS" name="total_pos" style={{ marginTop: -15 }}>
                                        <InputNumber autoComplete="off" style={{ width: "100%" }} />
                                    </Form.Item>
                                    <Form.Item label="Total Bl Awb" name="total_master_bl_awb" style={{ marginTop: -15 }}>
                                        <InputNumber autoComplete="off" style={{ width: "100%" }} />
                                    </Form.Item>
                                    <Form.Item
                                        label="Pemberitahu"
                                        name="pemberitahu"
                                        rules={[{ required: true, message: 'Pemberitahu wajib di isi' }]}
                                        style={{ marginTop: -15 }}
                                    >
                                        <Input
                                            autoComplete="off"
                                            onInput={e => e.target.value = e.target.value.toUpperCase()}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={12} style={{ marginTop: 15 }}>
                                    <Form.Item label="Total Kemasan" name="total_kemasan"
                                        style={{ marginTop: -15 }}
                                        rules={[{ required: true, message: 'Total Kemasan wajib di isi' }]}
                                    >
                                        <InputNumber autoComplete="off" style={{ width: "100%" }} />
                                    </Form.Item>
                                    <Form.Item label="Total Bruto" name="total_bruto" style={{ marginTop: -15 }}
                                        rules={[{ required: true, message: 'Total Bruto wajib di isi' }]}
                                    >
                                        <InputNumber
                                            autoComplete="off"
                                            style={{ width: "100%" }}
                                            formatter={formatTwoDecimalDisplay}
                                            parser={parseTwoDecimalValue}
                                        />
                                    </Form.Item>
                                    <Form.Item label="Total Volume" name="total_volume" style={{ marginTop: -15 }}
                                        rules={[{ required: true, message: 'Total Volume wajib di isi' }]}
                                    >
                                        <InputNumber
                                            autoComplete="off"
                                            style={{ width: "100%" }}
                                            formatter={formatTwoDecimalDisplay}
                                            parser={parseTwoDecimalValue}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </TabPane>

                <TabPane
                    tab={
                        <>
                            <InboxOutlined style={{ marginRight: 4 }} />
                            Bill Of Lading
                        </>
                    }
                    key="2">
                    <div
                        style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            justifyContent: 'space-between',
                            gap: 12,
                            alignItems: 'center',
                            marginBottom: 12
                        }}
                    >
                        <Input
                            allowClear
                            placeholder="Cari Master AWB / Host AWB"
                            value={billSearchKeyword}
                            onChange={(e) => setBillSearchKeyword(e.target.value)}
                            style={{ minWidth: 260, maxWidth: 360 }}
                        />
                        <Button type="primary" onClick={showDetilModal} icon={<PlusCircleOutlined />}>Tambah Data</Button>
                    </div>
                    <Table
                        size="small"
                        columns={detilColumns}
                        dataSource={filteredDetilData}
                        pagination={false}
                        rowKey="id_detil"
                        summary={() => (
                            <Table.Summary.Row>
                                <Table.Summary.Cell>Total</Table.Summary.Cell>
                                <Table.Summary.Cell></Table.Summary.Cell>
                                <Table.Summary.Cell></Table.Summary.Cell>
                                <Table.Summary.Cell></Table.Summary.Cell>
                                <Table.Summary.Cell></Table.Summary.Cell>
                                <Table.Summary.Cell>{jumlahKemasan}</Table.Summary.Cell>
                                <Table.Summary.Cell>{totalKemasan}</Table.Summary.Cell>
                                <Table.Summary.Cell>{totalBruto}</Table.Summary.Cell>
                                <Table.Summary.Cell></Table.Summary.Cell>
                            </Table.Summary.Row>
                        )}
                    />
                </TabPane>
            </Tabs>

            <Space style={{ marginTop: 20 }}>
                <Button type="primary" onClick={() => form.submit()} icon={<SaveOutlined />}>
                    Simpan
                </Button>
                <Button onClick={() => history.goBack()} icon={<ArrowLeftOutlined />} danger>Kembali</Button>
            </Space>

            <BillModal
                isDetilModalVisible={isDetilModalVisible}
                handleDetilModalCancel={handleDetilModalCancel}
                modalDetilForm={modalDetilForm}
                handleDetilModalOk={handleDetilModalOk}
                formatAwbNumber={formatAwbNumber}
                arps={arps}
                cns={cns}
                form={form}
                kdKemas={kdKemas}
                handleNext={handleNext}
                handleBack={handleBack}
                handleSelectDetil={handleSelectDetil}
                editingDetilIndex={editingDetilIndex}
                detilList={detilList}
                modalBarangForm={modalBarangForm}
                hscodeCache={hscodeCache}
                model={model}
            />
        </Form>
    );
}